const PNGGO_PLAY_URL = 'https://pnggo.bet/RFLANDINGPAGEPNG';

const pngPromos = [
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/b980d6a0534af443b817141cbc04bfb8.png',
    title: 'Free Cash PGK 70',
    desc: 'Claim your free cash reward — PGK 70 credited for eligible players.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/1a5bdd9385b3bebb7ba8ca272fc56042.png',
    title: 'Welcome Slot Bonus 80%',
    desc: 'Boost your slot play with an 80% welcome bonus on slots — see promo terms for details.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/b20ee0064063e5db6141b66033e5cea0.png',
    title: 'Monthly Commission Deposit Ranking',
    desc: 'Climb the monthly deposit leaderboard and earn commission-style rewards based on your ranking.',
  },
];

const pngPromos2 = [
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/07bb44ca8be11529de2a046187a68897.png',
    title: 'Weekly Rebate Level 9',
    desc: 'Reach Level 9 on the weekly rebate tier — up to PGK 2,388 in rebate rewards.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/384b1c0c4ca5bbb60dc1973b93d317cc.png',
    title: 'Daily Deposit Bonus K229–K259',
    desc: 'Deposit daily to unlock a K229–K259 bonus — claim your reward and start playing today.',
  },
  {
    img: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/cbf424a2da88c7e7a7cc5fc4079c3db3.png',
    title: 'Daily First Deposit 20%',
    desc: 'Make your first deposit of the day and claim a 20% bonus — ideal for sports freebets and more.',
  },
];

function PromoCard({ img, title, desc, href }: { img: string; title: string; desc: string; href: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-4 bg-[#1a1a1a] rounded-xl p-3 border border-white/5 hover:border-[#B80E28]/40 transition-all duration-300 group cursor-pointer"
    >
      <div className="w-20 h-16 flex-shrink-0 rounded-lg overflow-hidden">
        <img src={img} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
      </div>
      <div>
        <h4 className="text-white font-semibold text-sm mb-1">{title}</h4>
        <p className="text-white/55 text-xs leading-5">{desc}</p>
      </div>
    </a>
  );
}

export default function PromotionsSection() {
  return (
    <section className="relative bg-[#0d0d0d] py-16 pnggo-section-motif overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.12] pnggo-tapa-accent" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="mb-10">
          <p className="text-[#B80E28] text-xs font-semibold tracking-widest uppercase mb-2">
            Claim Today’s Deals — Updated Promotions
          </p>
          <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">
            Best Casino Promotions in Papua New Guinea
          </h2>
          <p className="text-white/60 text-sm leading-7 max-w-2xl">
            Start stronger with promos that match how PNG players actually play —{' '}
            <strong className="text-white">slots</strong>,{' '}
            <strong className="text-white">live casino</strong>, and{' '}
            <strong className="text-white">sports</strong>. Pick an offer below, tap in, and start playing in PGK today.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* PNG Promos 1 */}
          <div>
            <h3 className="text-white text-xl font-bold mb-5 flex items-center gap-2">
              <span className="w-1 h-5 bg-[#B80E28] rounded-full inline-block"></span>
              PAPUA NEW GUINEA PROMOTION
            </h3>
            <div className="flex flex-col gap-4">
              {pngPromos.map((p, i) => (
                <PromoCard key={i} {...p} href={PNGGO_PLAY_URL} />
              ))}
            </div>
          </div>

          {/* PNG Promos 2 */}
          <div>
            <h3 className="text-white text-xl font-bold mb-5 flex items-center gap-2">
              <span className="w-1 h-5 bg-[#B80E28] rounded-full inline-block"></span>
              EXCLUSIVE PNGGO OFFERS
            </h3>
            <div className="flex flex-col gap-4">
              {pngPromos2.map((p, i) => (
                <PromoCard key={i} {...p} href={PNGGO_PLAY_URL} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
